export const itemsPerPageCount = 15;